<div class="upload-box template-card" [class.card-opacity]="isOpaque()">
  <div class="step-title small">
    <span class="step-number">2</span>
    <h3>{{ 'downloadTemplate' | translate }}</h3>
  </div>
  <div class="template-header">
    <div class="card-icon-container">
      <img
        src="assets/images/fichero-sura.svg"
        alt="Icono Fichero"
        class="card-icon"
      />
    </div>
    <div class="template-text">
      <p>{{ 'downloadTemplateText' | translate }}</p>
      <span>{{ 'templateFormat' | translate }}</span>
    </div>
  </div>
  <div class="template-help">
    <ul>
      <li>
        <i class="pi pi-ban"></i>
        {{ 'doNotModifyColumns' | translate }}
      </li>
      <li>
        <i class="pi pi-check-square"></i>
        {{ 'fillRequiredFields' | translate }}
      </li>
    </ul>
  </div>
  <div class="template-actions">
    <app-button
      class="template-button"
      [data]="{
        id: 'download-template',
        label: 'downloadTemplate' | translate,
        icon: isDownloading() ? 'pi-spin pi-spinner' : 'pi-cloud-download'
      }"
      [loading]="isDownloading()"
      [disabled]="isDisabled() || isDownloading()"
      (click)="download.emit()"
    ></app-button>
  </div>
</div>
